const PARAGRAPH_GLOSSARY = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
    ... on Glossary {
      id
      glossary
      height
      chineseStroke {
        name
        weight
      }
      type
      uuid
    }
  }
`;

export default PARAGRAPH_GLOSSARY;
